// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"styles_buttonsContainer__Taz35","modalContent":"styles_modalContent__0wfNN"};